<div style="height: calc(100%); width: 100%;" data-cy="drawing-tools-container">
  <mat-grid-list cols="5" rowHeight="100%" style="height:100%;" data-cy="drawing-tools-grid">
    <mat-grid-tile colspan="5" data-cy="drawing-tools-tile">
      <mat-card appearance="outlined" style="width: 100%; height: calc(100%); display: flex; flex-direction: column;" data-cy="drawing-tools-card">
        <span class="configuration-section-title" data-cy="drawing-tools-title">Drawing Tools</span>
        <app-tdo-configuration-action-bar newHidden="true"
                                          (saveClick)="onSave($event)" data-cy="drawing-tools-action-bar"></app-tdo-configuration-action-bar>
        <mat-card-title data-cy="drawing-tools-arrow-title">Arrow Object</mat-card-title>
        <mat-card-subtitle data-cy="drawing-tools-arrow-subtitle">The maximum length of the arrow head.</mat-card-subtitle>
        <div class="form-group row" data-cy="drawing-tools-use-ratio-container">
          <p data-cy="drawing-tools-use-ratio-field">
            <mat-checkbox class="col-10" [checked]="useRatio"
                          (change)="useRatio = $event.checked; configurationService.setDirty();" data-cy="drawing-tools-use-ratio-checkbox">
              Use ratio of the arrow length to determine the size of the arrowhead. (1/n)
            </mat-checkbox>

          </p>
        </div>

        <div class="form-group row" data-cy="drawing-tools-arrow-head-container">
          <label class="col-10 col-form-label" *ngIf="!useRatio" data-cy="drawing-tools-arrow-head-length-label">Arrow Head Length</label>
          <label class="col-10 col-form-label" *ngIf="useRatio" data-cy="drawing-tools-arrow-size-ratio-label">Arrow Size (1/n)</label>
          <div style="margin-left: 12px; width: 25%;" data-cy="drawing-tools-arrow-head-input-container">
            <input type="number" min="1" class="form-control" style="width: 100%;" [value]="arrowHeadLength"
                   (input)="arrowHeadLength = $event.target.value" data-cy="drawing-tools-arrow-head-input">
          </div>
        </div>

        <div class="form-group row" data-cy="drawing-tools-fill-arrowhead-container">
          <p data-cy="drawing-tools-fill-arrowhead-field">
            <mat-checkbox class="col-10" [checked]="fillArrowhead"
                          (change)="fillArrowhead = $event.checked; configurationService.setDirty();" data-cy="drawing-tools-fill-arrowhead-checkbox">
              Fill arrowhead
            </mat-checkbox>

          </p>
        </div>

      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>
